// extracted by mini-css-extract-plugin
export var banner = "_tc-0";
export var settingRow = "_tc-2";
export var titleIcon = "_tc-1";